
import Vue from 'vue'
import GlobalService from '@/services/GlobalService'
import SelectConfigDialog from '@/components/MenuBar/SelectConfigDialog.vue'
interface PathL1Seed {
  path : string,
  l1seeds : string
}
export default Vue.extend({
  name: 'L1SeedsView',
  data() :{
    headers: { text: string, value: string }[],
    loading: boolean,
    error?: string,
    pathl1seeds?: PathL1Seed[],
    cfgSelection: string,
    selectConfigVisible: boolean,
    selectConfigOutLoc: string,
    pathFilter: string,
    l1seedFilter: string
  }{
    return {      
      headers : [
        {text: "Path", value: "path"},
        {text: "L1 seeds", value : "l1seeds"},
      ],
      loading : false,
      cfgSelection : '',
      selectConfigVisible :false,
      selectConfigOutLoc: "",
      pathFilter : "",
      l1seedFilter : "",
      pathl1seeds : undefined,
      error : undefined
      

    }
  },
  components :{
    SelectConfigDialog : SelectConfigDialog
  },

  computed : {
    pathL1TblItems() : PathL1Seed[]{
      if(this.pathl1seeds==undefined){
        return []
      }
      console.log(this.pathl1seeds)
      return this.pathl1seeds.filter(
        (item : any) => {
          return (item.path.includes(this.pathFilter) || this.pathFilter==="")
                 && (item.l1seeds.includes(this.l1seedFilter) || this.l1seedFilter==="") && item.l1seeds.length>0
        }
      ).      
      
      map((item : any) => {
        return {
          path : item.path,
          l1seeds : item.l1seeds
        }
      })
    }
  },

  methods: {  
    async loadL1Seeds(){
      if(this.cfg==undefined || this.cfg==''){
        return
      }
      this.error = undefined
      this.loading = true
      return GlobalService.getPathL1Seeds(this.cfg)
        .then((response) => {          
          if(response.data.status=="SUCCESS"){
            console.log(response)
            this.pathl1seeds = response.data.result.pathseeds
          }else{
            this.error = response.data.result
          }          
          this.loading=false
        }).catch((error ) => {
          this.loading=false
          console.log(error)
          this.error = error
        })      
    },
    load(){
      console.log("load", this.cfgSelection, this.cfg)
      if(this.cfgSelection!=this.cfg){
        this.pathl1seeds = undefined
        this.loading = true
        this.$router.push({path: "l1seeds", query: {cfg: this.cfgSelection}})
      }
    },
    selectConfigName(outLoc : string){
      this.selectConfigVisible = true
      this.selectConfigOutLoc = outLoc     
    }

  },

  props:{
    cfg : {
      type: String,
      default : ''    
    },
  },
  created(): void{
    if(this.cfg!='') {
      this.cfgSelection = this.cfg
      this.loadL1Seeds()
    }
  },
  watch: {
    cfg : function(newVal: string):void {     
      this.cfgSelection = newVal
      this.loadL1Seeds()
    },
    
  }
  
})
